/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unsaved_ChangesInputs */

const en_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved Changes`)
};

const es_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios sin guardar`)
};

const fr_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications non enregistrées`)
};

const de_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungespeicherte Änderungen`)
};

const ja_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未保存の変更`)
};

const zh_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未保存的更改`)
};

const ar_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغييرات غير محفوظة`)
};

const id_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan Belum Disimpan`)
};

const it_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche Non Salvate`)
};

const ru_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Несохраненные изменения`)
};

const pt_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações Não Salvas`)
};

const ko_unsaved_changes = /** @type {(inputs: Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장되지 않은 변경 사항`)
};

/**
* | output |
* | --- |
* | "Unsaved Changes" |
*
* @param {Unsaved_ChangesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unsaved_changes = /** @type {((inputs?: Unsaved_ChangesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsaved_ChangesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unsaved_changes(inputs)
	if (locale === "es") return es_unsaved_changes(inputs)
	if (locale === "fr") return fr_unsaved_changes(inputs)
	if (locale === "de") return de_unsaved_changes(inputs)
	if (locale === "ja") return ja_unsaved_changes(inputs)
	if (locale === "zh") return zh_unsaved_changes(inputs)
	if (locale === "ar") return ar_unsaved_changes(inputs)
	if (locale === "id") return id_unsaved_changes(inputs)
	if (locale === "it") return it_unsaved_changes(inputs)
	if (locale === "ru") return ru_unsaved_changes(inputs)
	if (locale === "pt") return pt_unsaved_changes(inputs)
	return ko_unsaved_changes(inputs)
});